// src/components/SignatureSvg.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';

// Canvas original do tablet: modal tem maxWidth 520px, altura 180px
// O viewBox precisa refletir essas dimensões pra escalar os paths corretamente
const SignatureSvg = ({ signatureSvgJson, width = 400, height = 120 }) => {
  let paths = [];
  try { if (signatureSvgJson) paths = JSON.parse(signatureSvgJson); } catch (_) {}

  if (!paths.length) {
    return (
      <Box sx={{
        width, height, border: '1px dashed #aaa',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backgroundColor: '#fafafa',
      }}>
        <Typography sx={{ fontSize: '8pt', color: '#aaa', fontStyle: 'italic' }}>No signature</Typography>
      </Box>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 520 180"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      style={{ border: '1px solid #ccc', backgroundColor: '#fafafa', display: 'block' }}
    >
      {paths.map((d, i) => (
        <path key={i} d={d} stroke="#111827" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      ))}
    </svg>
  );
};

export default SignatureSvg;